<template>
   <div class="proccessed-certificate-response width margin-left-3Perc container-fluid">
        <div id="myNav" class="overlay overlay-overall-width-100Perc">
          <div class="overlay-content center-aligned-div white-porition-overlay-width-70Perc background-color-white fade-in">
              <div class="row">
                <div class="col-md-12 col-lg-12">
                  <div class="text-right close-text-font-style margin-right-2Perc cursor-pointer opacity-0" v-on:click="updateCloseOverlay($event)" :class="{'opacity-1' : allowToCloseWindow}">
                    <img src= "../assets/images/close.svg" class="img-responsive close-img-width-height margin-top-2Perc float-right" alt="close-icon">
                  </div>  
                </div>
              </div>
              <div class="row">
                  <div class="col-md-1 col-lg-1">
                  </div>
                  <div class="col-md-10 col-lg-10 black-font-color font-size-25px font-weight-bold">
                      {{alertTitle}}
                  </div>
                  <div class="col-md-1 col-lg-1">
                  </div>    
              </div>
              <div class="row margin-bottom-1Perc margin-top-2Perc vertical-align">
                <div class="col-md-3 col-lg-3">
                </div>
                <div class="col-md-1 col-lg-1 padding-right-0px">
                  <div class="loader" v-if="!allowToCloseWindow"></div>
                </div>    
                <div class="col-md-1 col-lg-1 font-weight-bold font-size-16px text-align-right padding-left-0px padding-right-0px">
                  Status:&nbsp;
                </div>
                <div class="col-md-6 col-lg-6 font-size-16px text-align-left padding-left-0px padding-right-0px">
                  Successfully processed {{allowToCloseWindow ? ' all the records.' : getResponseArr.length + ' out of ' + totalCertificateToGenerate + ' records.'}}
                </div>
                <div class="col-md-1 col-lg-1">
                </div>    
              </div>
              <div class="table-responsive margin-Top-6Perc overflow-x-hidden">
                <table class="table table-striped margin-top-2Perc">
                  <thead>
                    <tr>
                      <th class="text-align-center font-size-15px border-right">SR No.</th>
                      <th class="text-align-center font-size-15px border-right">Full Name</th>
                      <th class="text-align-center font-size-15px border-right">Status Code</th>
                      <th class="text-align-center font-size-15px">Description</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(responseObj, index) in getResponseArr" :key="index" class="text-color-tomato" :class="{'text-color-green' : responseObj.StatusCode >= 200 && responseObj.StatusCode<300}">
                    <td class="text-align-center border-right col-md-1 col-lg-1">{{(index + 1)}}</td>
                    <td class="text-align-center border-right col-md-4 col-lg-4">{{responseObj.Name}}</td>
                    <td class="text-align-center border-right col-md-1 col-lg-2">{{responseObj.StatusCode}}</td>
                    <td class="text-align-center border-right col-md-6 col-lg-5">{{responseObj.Description}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>  
              <div class="row margin-bottom-2Perc">
                  <div class="col-md-4 col-lg-4">
                  </div>
                  <div class="col-md-4 col-lg-4 padding-Bottom-1Perc">
                    <button type="button" class="btn black-border custom-btn white-BG font-size-16px font-color-blue opacity-0" v-on:click="updateCloseOverlay($event)" :disabled="!allowToCloseWindow" :class="{'opacity-1' : allowToCloseWindow}">{{closeBtnText}}</button>
                  </div>
                  <div class="col-md-4 col-lg-4"></div> 
              </div>
              <div class="row margin-top-1Perc margin-bottom-2Perc">
                  <div class="col-md-12 col-lg-12">
                  </div>
              </div>             
          </div>
      </div>
    </div> 
</template>
<script>
export default {
  props: ['respArr', 'totalCertificateToGenerate'],
  name: 'proccessed-certificate-response',
  data: function () {
    return {
      alertTitle: 'Mentora Admin',
      closeBtnText: 'Done'
    }
  },
  components: {},
  created: function () {},
  methods: {
    updateCloseOverlay: function (event) {
      this.$emit('showOverlay', false)
    }
  },
  computed: {
    getResponseArr: {
      get: function () {
        return this.respArr
      }
    },
    allowToCloseWindow: {
      get: function () {
        return this.totalCertificateToGenerate === 0 ? true : this.getResponseArr.length === this.totalCertificateToGenerate
      }
    }
  }
}
</script>

<style scoped>
.overflow-x-hidden {
  overflow-x: hidden;
}
.text-color-tomato {
  color: red;
}
.text-color-green {
  color: green !important;
}
.opacity-0 {
  opacity: 0;
}
.opacity-1 {
  opacity: 1 !important;
}
.padding-left-0px {
  padding-left: 0px;
}
.padding-right-0px {
  padding-right: 0px;
}
.font-weight-bold {
  font-weight: bold;
}
.white-BG {
  background-color: #ffffff;
}
.overlay-overall-width-100Perc {
  width: 100% !important;
}
.overlay-overall-width-0Perc {
  width: 0%;
}
.overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 1000;
  top: 0;
  left: 0;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.56);
  overflow-x: hidden;
  /*transition: 0.5s;*/
}

.overlay-content {
  position: relative;
  top: 15%;
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
.background-color-white {
  background-color: #ffffff !important;
}
.white-porition-overlay-width-70Perc {
  width: 70%;
}
.center-aligned-div {
  margin: 0 auto;
}

.overlay a {
  padding: 8px;
  text-decoration: none;
  font-size: 36px;
  color: #818181;
  display: block;
  transition: 0.3s;
}

.overlay a:hover,
.overlay a:focus {
  color: #f1f1f1;
}

.overlay .closebtn {
  position: absolute;
  top: 20px;
  right: 45px;
  font-size: 60px;
}
@media screen and (max-height: 450px) {
  .overlay a {
    font-size: 20px;
  }
  .overlay .closebtn {
    font-size: 40px;
    top: 15px;
    right: 35px;
  }
}
.close-text-font-style {
  color: #aaa;
  font-size: 30px;
}
.text-align-right {
  text-align: right !important;
}
.text-align-left {
  text-align: left !important;
}
.text-align-center {
  text-align: center !important;
}
.margin-right-2Perc {
  margin-right: 2%;
}
.width {
  width: 95%;
}
.create-lesson {
  overflow-y: hidden !important;
}
.background-gray {
  background-color: aqua;
}
.overflow-y-hidden {
  overflow-y: hidden !important;
}
.overflow-hidden {
  overflow: hidden;
}
.save-button-width {
  width: 60% !important;
}
.padding-Top-1Perc {
  padding-top: 1%;
}
.padding-Bottom-1Perc {
  padding-bottom: 1%;
}
.font-size-1-3vw {
  font-size: 1.3vw;
}
.font-size-16px {
  font-size: 16px;
}
.font-size-14px {
  font-size: 14px;
}
.font-size-25px {
  font-size: 25px;
}
.text-align-left {
  text-align: left;
}
.input-group .icon-addon .form-control {
  border-radius: 0;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.center-align-div {
  margin: 0 auto;
}
.margin-left-3Perc {
  margin-left: 3% !important;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 23px;
  width: 23px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #32cd32;
}

input:focus + .slider {
  box-shadow: 0 0 1px #32cd32;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
.border-color-red {
  border: 1px solid red;
}
.border-color-yellow {
  border: 1px solid yellow;
}
.create-lesson-input-text-style {
  color: #34495e;
  font-size: 17px;
}
.padding-right-0Px {
  padding-right: 0px !important;
}
.margin-bottom-2Perc {
  margin-bottom: 2%;
}
.black-font-color {
  color: #000;
}
.cursor-pointer {
  cursor: pointer;
}
.close-img-width-height {
  width: 3.5%;
  height: 3.5%;
}
.margin-top-1Perc {
  margin-top: 1%;
}
 .margin-top-2Perc {
  margin-top: 2%;
}
.float-right {
  float: right;
}
.font-color-blue {
  color: dodgerblue;
}
.border {
  border: 1px solid #aaa;
}
.margin-top-2Perc {
  margin-top: 2%;
}
.margin-bottom-5Perc {
  margin-bottom: 5%;
}
.margin-bottom-1Perc {
  margin-bottom: 1%;
}
.border-right {
  border-right: 1px solid #aaa !important;
}
.text-align-center {
  text-align: center !important;
}
.table-striped > tbody > tr:nth-child(2n + 1) > td,
.table-striped > tbody > tr:nth-child(2n + 1) > th {
  background-color: #ddd;
}
.margin-top-1px{
  margin:2%;
}
.table-border-1px{
  border:1px solid #aaa !important;
}
.custom-btn {
  padding: 6px 36px !important;
  border-radius:0px;
}
.black-border {
    border: 1px solid #aaa;
}
.loader {
  border: 3px solid #f3f3f3; /* Light grey */
  border-top: 3px solid #f39c12; /* Blue */
  border-radius: 50%;
  width: 23px;
  height: 23px;
  margin: auto;
  float: right;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>


// WEBPACK FOOTER //
// src/components/ProccessedCertificateResponse.vue